var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.2266 7.4873C10.2266 7.25098 10.1406 7.03613 9.95801 6.85352L3.31934 0.257812C3.1582 0.0859375 2.94336 0 2.69629 0C2.19141 0 1.80469 0.375977 1.80469 0.880859C1.80469 1.11719 1.91211 1.34277 2.0625 1.51465L8.06738 7.4873L2.0625 13.46C1.91211 13.6318 1.80469 13.8467 1.80469 14.0938C1.80469 14.5986 2.19141 14.9746 2.69629 14.9746C2.94336 14.9746 3.1582 14.8887 3.31934 14.7168L9.95801 8.12109C10.1406 7.93848 10.2266 7.72363 10.2266 7.4873Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.373efff459e1e8a72d1be1b841d07ea4.svg";
export { ForwardRef as ReactComponent };